import React, { useRef } from "react";
import Slider from "react-slick";
import TrackVisibility from "react-on-screen";

import { ReactComponent as LeftArrow } from "../assets/img/arrow1.svg";
import { ReactComponent as RightArrow } from "../assets/img/arrow2.svg";

import pythonImg from "../assets/img/skillicons/python.svg";
import cplusImg from "../assets/img/skillicons/cplus.svg";
import javaImg from "../assets/img/skillicons/java.svg";
import javascriptImg from "../assets/img/skillicons/javascript.svg";
import htmlImg from "../assets/img/skillicons/html.svg";
import cssImg from "../assets/img/skillicons/css.svg";
import reactImg from "../assets/img/skillicons/react.svg";
import nodeImg from "../assets/img/skillicons/node.svg";
import pytorchImg from "../assets/img/skillicons/pytorch.svg";
import arduinoImg from "../assets/img/skillicons/arduino.svg";
import bashImg from "../assets/img/skillicons/bash.svg";
import firebaseImg from "../assets/img/skillicons/firebase.svg";
import gitImg from "../assets/img/skillicons/git.svg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "animate.css";

export const Skills = () => {
  const languages = [
    { name: "Python", img: pythonImg },
    { name: "C++", img: cplusImg },
    { name: "Java", img: javaImg },
    { name: "JavaScript", img: javascriptImg },
    { name: "HTML", img: htmlImg },
    { name: "CSS", img: cssImg },
  ];

  const frameworks = [
    { name: "React JS", img: reactImg },
    { name: "Node JS", img: nodeImg },
    { name: "PyTorch", img: pytorchImg },
    { name: "Arduino", img: arduinoImg },
  ];

  const tools = [
    { name: "Bash", img: bashImg },
    { name: "Firebase", img: firebaseImg },
    { name: "Git", img: gitImg },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  const sliderRef = useRef(null);

  return (
    <>
      <div
        id="skills"
        style={{ position: "relative", top: "-100px", visibility: "hidden" }}
      ></div>
      <section className="skill">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="skill-bx">
                <TrackVisibility>
                  {({ isVisible }) => (
                    <div
                      className={
                        isVisible ? "animate__animated animate__fadeIn" : ""
                      }
                    >
                      <h2>Skills</h2>
                      <p>
                        Here are my current skills that I've acquired throughout
                        my journey.
                        <br />I am continually expanding my expertise to stay
                        ahead in the ever-evolving tech landscape.
                      </p>
                    </div>
                  )}
                </TrackVisibility>

                <TrackVisibility>
                  {({ isVisible }) => (
                    <div
                      className={
                        isVisible
                          ? "animate__animated animate__fadeInRight"
                          : ""
                      }
                    >
                      <Slider ref={sliderRef} {...settings}>
                        <div className="skill-group">
                          <h3>Languages</h3>
                          <div className="skill-grid">
                            {languages.map((skill, index) => (
                              <div className="skill-item" key={index}>
                                <img src={skill.img} alt={skill.name} />
                                <h5>{skill.name}</h5>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div className="skill-group">
                          <h3>Frameworks</h3>
                          <div className="skill-grid">
                            {frameworks.map((skill, index) => (
                              <div className="skill-item" key={index}>
                                <img src={skill.img} alt={skill.name} />
                                <h5>{skill.name}</h5>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div className="skill-group">
                          <h3>Others</h3>
                          <div className="skill-grid">
                            {tools.map((skill, index) => (
                              <div className="skill-item" key={index}>
                                <img src={skill.img} alt={skill.name} />
                                <h5>{skill.name}</h5>
                              </div>
                            ))}
                          </div>
                        </div>
                      </Slider>
                    </div>
                  )}
                </TrackVisibility>

                <div className="slider-nav-arrows">
                  <LeftArrow
                    className="custom-prev-arrow"
                    onClick={() => sliderRef.current?.slickPrev()}
                  />
                  <RightArrow
                    className="custom-next-arrow"
                    onClick={() => sliderRef.current?.slickNext()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
